module.exports = __webpack_public_path__ + "static/media/close-dollor-white.c552fa46.svg";